import { render, staticRenderFns } from "./printTipsCom.vue?vue&type=template&id=76b5f900&scoped=true"
import script from "./printTipsCom.vue?vue&type=script&lang=js"
export * from "./printTipsCom.vue?vue&type=script&lang=js"
import style0 from "./printTipsCom.vue?vue&type=style&index=0&id=76b5f900&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b5f900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b5f900')) {
      api.createRecord('76b5f900', component.options)
    } else {
      api.reload('76b5f900', component.options)
    }
    module.hot.accept("./printTipsCom.vue?vue&type=template&id=76b5f900&scoped=true", function () {
      api.rerender('76b5f900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operatingPlatform/ChangeSingleCollectionBag/component/printTipsCom.vue"
export default component.exports